const Index = () => import("./index.vue");
const CreatePage = () => import("./_pages/create.vue");
const ViewPage = () => import("./_pages/view.vue");

export default [
  {
    path: "/payment-terms",
    component: Index,
  },
  {
    path: "/new-payment-terms",
    component: CreatePage,
  },
  {
    path: "/payment-terms/:id",
    component: ViewPage,
  },
];
